export default "__VITE_ASSET__CCDk2hbj__"